import "./home.css";
import { useState } from "react";
import Header from "../../components/Header";
import SideBar from "../../components/SideBar";
import { useNavigate } from "react-router-dom";
import { RiMoneyDollarCircleFill, } from "react-icons/ri";
import PaymentMethodModal from "../../components/PaymentMethodModal";
import { FaCrown,FaBusinessTime } from "react-icons/fa";
import { CgEditMarkup } from "react-icons/cg";

//
const Home = () => {
  const navigate = useNavigate()
  const [open, setOpen] = useState(false);
  
  const [paymentMethods, setPaymentMethods] = useState({
    skrill: false,
    card: false,
  });
 
  const handlePaymentChange = (event) => {
    console.log(`Checkbox changed: ${event.target.name}, Value: ${event.target.value}, Checked: ${event.target.checked}`);
    
    setPaymentMethods({
      ...paymentMethods,
      [event.target.name]: event.target.checked,
    });
  };
  

  return (
    <div className="main">

    <PaymentMethodModal
        open={open}
        setOpen={setOpen}
        setPaymentMethods={setPaymentMethods}
        handlePaymentChange={handlePaymentChange}
      />


      <div id="Sportbook">
        <div className="container bg-color-sportbook custom-card4">
          <div className="inner-space1">
            <div className="row">
              <div className="col-md-12">
                <h2 className="mb-4">Control Panel BettGaming</h2>
                <p className="custom-card4p">
                  Select the features in the menu above
                </p>
              </div>
            </div>
            <div className="row" style={{ backgroundColor: '#fff', padding: '5px 0px 20px 0px' }}>
              <div className="col-md-8 mx-auto">
                <div className="row">

                <div className="col-md-3" onClick={() => navigate("/UserList")}>
                    <div className="card-box">
                    <img width={'64px'} src="/images/icons/uaers.png" />
                      <h4>Users</h4>
                    </div>
                  </div>
                  <div className="col-md-3" onClick={() => navigate("/Transfer")}>
                    <div className="card-box">
                     
                      <img src="/images/icons/Box_recycle.png" />
                      <h4>Transfer</h4>
                    </div>
                  </div>

                  <div className="col-md-3" onClick={() => setOpen(true)}>
                    <div className="card-box">
                      <img src="/images/icons/Box_recycle.png" alt="Payment Method" />
                      <h4>Payment Method</h4>
                    </div>
                  </div>

                  <div className="col-md-3" onClick={() => navigate("/loyalty")}>
                    <div className="card-box">
                     <FaCrown style={{fontSize:"60px"}}/>
                      <h4>Loyalty</h4>
                    </div>
                  </div>

                  <div className="col-md-3" onClick={() => navigate("/config-list")}>
                    <div className="card-box">
                     <FaCrown style={{fontSize:"60px"}}/>
                      <h4>Configuration Page</h4>
                    </div>
                  </div>
                  
                  <div className="col-md-3" onClick={() => navigate("/offer-list")}>
                    <div className="card-box">
                     <FaCrown style={{fontSize:"60px"}}/>
                      <h4>Offer Post Page</h4>
                    </div>
                  </div>
                
                  <div className="col-md-3" onClick={() => navigate("/mailIn-list")}>
                    <div className="card-box">
                     <FaCrown style={{fontSize:"60px"}}/>
                      <h4>Mail In Feature Page</h4>
                    </div>
                  </div>

                  <div className="col-md-3" onClick={() => navigate("/casino-subscribers")}>
                    <div className="card-box">
                     <FaCrown style={{fontSize:"60px"}}/>
                      <h4>Casino Subscribers</h4>
                    </div>
                  </div>

                 <div className="col-md-3" onClick={() => navigate("/all-promotions")}>
                    <div className="card-box">
                     <FaCrown style={{fontSize:"60px"}}/>
                      <h4>All Promotions</h4>
                    </div>
                  </div>

                  <div className="col-md-3" onClick={() => navigate("/affiliate-marketing")}>
                    <div className="card-box">
                     <FaBusinessTime style={{fontSize:"60px"}}/>
                      <h4 style={{marginTop:"10px"}}>Affiliate Marketing</h4>
                    </div>
                  </div>

                  <div className="col-md-3" onClick={() => navigate("/utm-report")}>
                    <div className="card-box">
                     <FaBusinessTime style={{fontSize:"60px"}}/>
                      <h4 style={{marginTop:"10px"}}>UTM Report</h4>
                    </div>
                  </div>

                  <div className="col-md-3" onClick={() => navigate("/kyc-list")}>
                    <div className="card-box">
                     <FaCrown style={{fontSize:"60px"}}/>
                      <h4>KYC List</h4>
                    </div>
                  </div>

                  <div className="col-md-3" onClick={() => navigate("/block-domain")}>
                    <div className="card-box">
                     <FaCrown style={{fontSize:"60px"}}/>
                      <h4>Block Domain</h4>
                    </div>
                  </div>

                  <div className="col-md-3" onClick={() => navigate("/happy-hour")}>
                    <div className="card-box">
                     <FaBusinessTime style={{fontSize:"60px"}}/>
                      <h4>Happy Hour</h4>
                    </div>
                  </div>

                  <div className="col-md-3" onClick={() => navigate("/lottery")}>
                    <div className="card-box">
                     <FaCrown style={{fontSize:"60px"}}/>
                      <h4>Lottery</h4>
                    </div>
                  </div>

                  {/* <div className="col-md-3" onClick={() => navigate("/wheel-of-fortune")}>
                    <div className="card-box">
                     <FaCrown style={{fontSize:"60px"}}/>
                      <h4>WOF Configuration</h4>
                    </div>
                  </div>

                   <div className="col-md-3" onClick={() => navigate("/monthly-promotions")}>
                    <div className="card-box">
                     <FaCrown style={{fontSize:"60px"}}/>
                      <h4>Monthly Promotions</h4>
                    </div>
                  </div> */}
                
                  {/* <div className="col-md-3" onClick={() => navigate("/Bets")}>
                    <div className="card-box" >
                      <img src="/images/icons/Book_phones.png" />
                      <h4>Bets</h4>
                    </div>
                  </div>
                  <div className="col-md-3" onClick={() => navigate("/Results")} >
                    <div className="card-box">
                      <img src="/images/icons/Clipboard_3.png" />
                      <h4>Results</h4>
                    </div>
                  </div> */}
                 
     
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
